export function getAddressAutocompleteDropdownMountEl(inputEl) {
  if (typeof document === "undefined") return null;
  if (inputEl && typeof inputEl.closest === "function") {
    const themed = inputEl.closest("[data-theme]") || inputEl.closest("#nitromule-react-root") || inputEl.closest("#admin-dashboard-root") || inputEl.closest(".nm-react-widget-root") || inputEl.closest(".home-content-wrapper") || inputEl.closest(".nm-quote-embed") || inputEl.closest(".order-details-modal-theme-wrapper");
    if (themed) return themed;
  }
  return document.querySelector("#nitromule-react-root") || document.querySelector("#admin-dashboard-root") || document.querySelector(".nm-react-widget-root") || document.querySelector(".home-content-wrapper") || document.body;
}

/** Match workspace / app theme for portaled address-suggest menus. */
export function addressSuggestDropdownThemeFromInput(inputEl, { forceLight = false } = {}) {
  if (forceLight) return "light";
  if (!inputEl || typeof inputEl.closest !== "function") return "light";
  if (inputEl.closest(".nm-workspace-shell.dark, .nm-workspace-shell .dark")) return "dark";
  const themed = inputEl.closest("[data-theme]") || inputEl.closest("#nitromule-react-root") || inputEl.closest(".home-content-wrapper");
  const t = themed?.getAttribute?.("data-theme");
  return t === "dark" ? "dark" : "light";
}

export function applyAddressSuggestDropdownTheme(dd, inputEl, opts) {
  if (!dd) return;
  dd.setAttribute("data-theme", addressSuggestDropdownThemeFromInput(inputEl, opts));
}
